var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationMarkerA4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LocationMarker_A4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LocationMarker_A4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 7.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C7.12875,0 0,6.34195455 0,14.1673636 C0,21.9909091 3.75,27.9545455 15,41 C26.25,27.9545455 30,21.9909091 30,14.1673636 C30,6.34195455 22.873125,0 15,0 Z",
    id: "Shape",
    fill: "#124B4F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "A4",
    transform: "translate(4.914062, 8.531250)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4296875,11.46875 L7.6015625,8.75 L3.4375,8.75 L2.609375,11.46875 L0,11.46875 L4.03125,0 L6.9921875,0 L11.0390625,11.46875 L8.4296875,11.46875 Z M7.0234375,6.71875 C6.2578125,4.25520833 5.82682292,2.86197917 5.73046875,2.5390625 C5.63411458,2.21614583 5.56510417,1.9609375 5.5234375,1.7734375 C5.3515625,2.44010417 4.859375,4.08854167 4.046875,6.71875 L7.0234375,6.71875 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.921875,9.1015625 L18.546875,9.1015625 L18.546875,11.46875 L16.1875,11.46875 L16.1875,9.1015625 L11.3125,9.1015625 L11.3125,7.421875 L16.3203125,0.046875 L18.546875,0.046875 L18.546875,7.2265625 L19.921875,7.2265625 L19.921875,9.1015625 Z M16.1875,7.2265625 L16.1875,5.2890625 C16.1875,4.96614583 16.2005208,4.49739583 16.2265625,3.8828125 C16.2526042,3.26822917 16.2734375,2.91145833 16.2890625,2.8125 L16.2265625,2.8125 C16.0338542,3.23958333 15.8020833,3.65625 15.53125,4.0625 L13.4375,7.2265625 L16.1875,7.2265625 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerA4);
export default __webpack_public_path__ + "static/media/LocationMarker_A4.7fa7c3e11ef12aeb2b8d85f4b980ac86.svg";
export { ForwardRef as ReactComponent };